import Vue from "vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";

/**
 * The Mira edition the app bar names on every Mira page, "Aus der Werkstatt · Oktober 2026" (Hans,
 * #2610137: the label of the beta showcase). The year and month of the edition, not of the data, which
 * carries its own "Stand" date: changed by hand with each showcase.
 */
export const MIRA_EDITION = "2026-10";

/**
 * A Mira page's title with the edition after it: "Trocknung · Aus der Werkstatt · Oktober 2026". The month
 * is written in the user's language by the browser, so a new edition is this one constant.
 */
export function miraEditionTitle(title: string, t: (key: string, params: string[]) => string, locale: string): string {
  const [year, month] = MIRA_EDITION.split("-").map(Number);
  const edition = new Intl.DateTimeFormat(locale, { month: "long", year: "numeric", timeZone: "UTC" }).format(
    new Date(Date.UTC(year, month - 1, 1))
  );
  return t("mira.edition", [title, edition]);
}

/** Sets a Mira page's app bar title, its translated title with the edition. Called again on a language change. */
export function setMiraToolbarTitle(vm: Vue, titleKey: string): void {
  ToolbarContentModule.setToolbarTitle(
    miraEditionTitle(vm.$t(titleKey).toString(), (key, params) => vm.$t(key, params).toString(), vm.$i18n?.locale ?? "de")
  );
}
